export default "__VITE_ASSET__8811cf81__"